import React, { useState, useEffect ,useRef} from "react";


const Header = () => {
  // menu bar open and close  start
  const [showNavbar, setShowNavbar]= useState(false);

  let menuRef = useRef();
  useEffect(()=>{
     let handler = (event) => {
      if(!menuRef.current.contains(event.target)){
        setShowNavbar(false);
      }
     }; 
     return ()=> {
    document.addEventListener("mousedown",handler);
    }
  })
  // menu bar open and close  end

   
 
  
 
 
  





  const [isSelected, setIsSelected] = useState("");
  const menus = [{'Home':'#intro'},{'Products':'#products'},{'Services':'#services'},{'Expertise':'#expertise'},{'Our Team':'#team'},{'Portfolio':'#portfolio'},{'Testimonials':'#testimonials'},{'About Us':'#about'},{'Contact Us':'#contact'}];
  
   
  
  const handleClick =(e)=> {
    menus.forEach((menu) => {
      Object.keys(menu).forEach((key)=>{
          if ( (e.target.href).lastIndexOf(menu[key]) > 0 ) {
              console.log(e.target.innerText);    
              setIsSelected(key);
          }
      }) 
    })
  }
 
 
  /* smooth scroll — redirects to home page if on another page */
  let handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const isOnHomePage = window.location.pathname.includes('/home');
    if (!isOnHomePage) {
      // Navigate to home page with the section hash so it scrolls after load
      window.location.href = '/en/home' + targetId;
      return;
    }
    const target = document.querySelector(targetId);
    if (target) {
      let top_space = 140;
      const header = document.getElementById('header');
      if (header) {
        const subHeader = document.querySelector('.sub-header-banner');
        const bannerHeight = subHeader ? subHeader.offsetHeight : 44;
        top_space = header.offsetHeight + bannerHeight + 15;
      }
      window.scroll({
        top: target.offsetTop - top_space,
        behavior: 'smooth',
      });
    }
  };
  /* end */
 
 

  return (
    <>
      {/*==========================
    Header 
    ============================*/}
      <header ref={menuRef}  id="header" className="fixed-top">
        <div className="container">
          <div className="logo float-left">
            {/* Uncomment below if you prefer to use an image logo */}

            <h1 className="text-light">
              <div className="float-left mr-2">
                <a href="#header" onClick={(e) => handleSmoothScroll(e, '#header')}>
                  <img src="/img/mvit-logo.jpg" alt="Microvision Infotech Logo" />
                </a>
              </div>
              <div className="float-left text-left">
                <a href="#header" onClick={(e) => handleSmoothScroll(e, '#header')}>
                  <span>
                    Microvision <br /> Infotech
                  </span>
                </a>
              </div>
            </h1>
            {/* <a href="#intro" className="scrollto" onClick={(e) => handleSmoothScroll(e, '#intro')}  ><img src="img/logo.png" alt="" className="img-fluid"/></a> */}
          </div>

          <nav     className={showNavbar ? "main-nav mobile-nav" : "main-nav d-none d-lg-block " }  >
            <ul className="mr-auto">
              {/* 1. Home */}
              <li key="m1" className="active nav-item-home">
                <a
                  className={ isSelected === 'Home' ? 'd-none' : '' }
                  href="#intro"  
                  onClick={  ( (e)=> { handleClick(e);  setShowNavbar(false); handleSmoothScroll(e, "#intro"); }  ) }  
                > 
                  Home   
                </a>  
                <span className={ isSelected === 'Home' ? '' : 'd-none' }>Home</span>
              </li>
              {/* 2. Products */}
              <li key="m_products">
                <a
                  className={ isSelected === 'Products' ? 'd-none' : '' }
                  href="#products"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#products"); }  ) }   
                >
                  Products
                </a>
                <span className={ isSelected === 'Products' ? '' : 'd-none' }>Products</span>
              </li>
              {/* 3. Services */}
              <li key="m4">
                <a
                  className={ isSelected === 'Services' ? 'd-none' : '' }
                  href="#services"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#services"); }  ) }  
                >
                  Services
                </a>
                <span className={ isSelected === 'Services' ? '' : 'd-none' }>Services</span>
              </li>
              {/* 4. Expertise */}
              <li key="m_expertise">
                <a
                  className={ isSelected === 'Expertise' ? 'd-none' : '' }
                  href="#expertise"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#expertise"); }  ) }   
                >
                  Expertise
                </a>
                <span className={ isSelected === 'Expertise' ? '' : 'd-none' }>Expertise</span>
              </li>
              {/* 5. Our Team */}
              <li key="m_team">
                <a
                  className={ isSelected === 'Our Team' ? 'd-none' : '' }
                  href="#team"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#team"); }  ) }   
                >
                  Our Team
                </a>
                <span className={ isSelected === 'Our Team' ? '' : 'd-none' }>Our Team</span>
              </li>
              {/* 6. Portfolio */}
              <li key="m5">
                <a
                  className={ isSelected === 'Portfolio' ? 'd-none' : '' }
                  href="#portfolio"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#portfolio"); }  ) }   
                >
                  Portfolio
                </a>
                <span className={ isSelected === 'Portfolio' ? '' : 'd-none' }>Portfolio</span>
              </li>
              {/* 7. Testimonials */}
              <li key="m_testimonials" className="nav-item-testimonials">
                <a
                  className={ isSelected === 'Testimonials' ? 'd-none' : '' }
                  href="#testimonials"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#testimonials"); }  ) }   
                >
                  Testimonials
                </a>
                <span className={ isSelected === 'Testimonials' ? '' : 'd-none' }>Testimonials</span>
              </li>
              {/* 8. Careers */}
              <li key="m_careers">
                <a
                  href="/en/careers"
                  className={window.location.pathname.includes('/careers') ? 'careers-link active' : 'careers-link'}
                  onClick={() => setShowNavbar(false)}
                >
                  Careers
                </a>
              </li>
              {/* 9. About Us */}
              <li key="m3">
                <a
                  className={ isSelected === 'About Us' ? 'd-none' : '' }
                  href="#about"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#about"); }  ) }  
                >
                  About Us
                </a>
                <span className={ isSelected === 'About Us' ? '' : 'd-none' }>About Us</span>
              </li>
              {/* 10. Contact Us */}
              <li key="m7" className="nav-item-contact">
                <a
                  className={ isSelected === 'Contact Us' ? 'd-none' : '' } 
                  href="#contact"
                  onClick={  ( (e)=> { handleClick(e); setShowNavbar(false); handleSmoothScroll(e, "#contact"); }  ) }
                >
                  Contact Us
                </a>
                <span className={ isSelected === 'Contact Us' ? '' : 'd-none' }>Contact Us</span>
              </li>
            </ul>
          </nav>
          <button className="mobile-nav-toggle d-lg-none" onClick={() => setShowNavbar(!showNavbar)}>
            &#9776;
          </button>
          {/* .main-nav */}
        </div>
      </header>
      {/* #header */}
    </>
  );
};

export default Header;
